/* global $ */
import { Swiper, Navigation, Pagination, Autoplay, EffectFade } from 'swiper/dist/js/swiper.esm.js'

Swiper.use([Navigation, Pagination, Autoplay, EffectFade])

function init () {
  $(document).ready(function () {

    const thumbsElem = $('.swiper-container.realty-slider-thumbnails')
    let thumbsCount = 5
    if($(thumbsElem).find('.swiper-slide').length < 5) {
      thumbsCount = $(thumbsElem).find('.swiper-slide').length
    }
    var thumbnails = new Swiper(thumbsElem, {
        spaceBetween: 10,
        slidesPerView: thumbsCount,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
          599: {
            slidesPerView: 3
          }
        }
    });

    const swiperElem = $('.swiper-container.realty-slider')
    if (swiperElem.length === 0) {
      return
    }
    let loopVal = false;
    if ($(swiperElem).find('.swiper-slide').length > 1) {
      // loop only if swiper has more than 1 slide
      loopVal = true
    }
    const swiper = new Swiper(swiperElem, {
      loop: loopVal,
      watchOverflow: true,
      autoHeight: false,
      centeredSlides: true,
      thumbs: {
        swiper: thumbnails,
      },
      navigation: {
        nextEl: $(swiperElem).find('.swiper-button-next'),
        prevEl: $(swiperElem).find('.swiper-button-prev')
      }
    })
    swiper.init()

    $(document).on('click', '.single-realty .realty-slider .next-slide', function() {
      $(swiperElem).find('.swiper-button-next').click()
    })

    $(document).on('click', '.single-realty .realty-slider .prev-slide', function() {
      $(swiperElem).find('.swiper-button-prev').click()
    })
  })
}

export default {
  init
}
